import { READ, CLOUDREAD, FILTER, CLOUDFILTER, CLOUDFIND, FIND, CLOUDUPDATE, UPDATE, CLOUDCREATE, CREATE } from "./crud";
import { getFunctions, httpsCallable } from "firebase/functions";
import { functions } from "./configFirebase";


export class Datas {

    constructor(store) {
        this.store = store;
       }

    searchEngine(text) {
        let answer = {users: [], inventory: []}
        return new Promise(async (resolve, reject) => {
        this.load('USERS')
        .then(data => {
            answer.users = this.search(this.store.database.users, text)
            this.load('INVENTORY')
            .then(data => {
                answer.inventory = this.search(this.store.database.inventory, text)
                resolve(answer)
            })
        })
        .catch(error => { reject(error) })
    })

    }

    search(list, text){
        text = text.toLowerCase();
        return list.filter(item =>Object.values(item).some(value => String(value).toLowerCase().includes(text)));
    }

    checkBarcode(barcode) {
        return new Promise(async (resolve, reject) => {
        this.load('INVENTORY')
        .then(data => {
            let found = this.store.database.inventory.filter((item => item.barcode === barcode))
            if(found.length === 0){resolve(false)
            }else{resolve(true)}   
        })
        .catch(error => { reject(error) })
        })
    }

    getOffices() {
        return new Promise(async (resolve, reject) => {
        this.load('CITIES')
            .then(data => {resolve(this.store.database.cities.filter((city => (city.appearence === 'headoffice' || city.appearence === 'office'))));})
            .catch(error => { reject(error) })
        })
    }

    findOne(list, key, value) {
        return new Promise(async (resolve, reject) => {
            //HA A LIST EGY TÖMB
            if (Array.isArray(list)) {resolve(list.find(element => this.compareValues(element[key], value)));return;}
            //HA A LIST EGY REFERENCIA
            const one = await FIND(list, key, value);
            resolve(one);             
        })   
    }

/*
    findOne(list, key, value) {
        return new Promise(async (resolve, reject) => {
            //HA A LIST EGY TÖMB
            if (Array.isArray(list)) {resolve(list.find(element => this.compareValues(element[key], value)));return;}
            //HA A LIST EGY REFERENCIA
            this.load(list)
            .then(data => {resolve(this.store.database[list.toLowerCase()].find(element => this.compareValues(element[key], value)));             
            }).catch(error => { reject(error) })          
        })   
    }
*/


    filter(list, key, value) {
        return new Promise(async (resolve, reject) => {
            if (Array.isArray(list)) {resolve(list.filter(element => element[key] === value));
            return;}
            FILTER(list, key, value)
            .then(data => {resolve(data)
            }).catch(error => { reject(error) })       
        })   
    }

    compareValues(elementValue, value) {
        if (typeof elementValue === 'string') {return elementValue === value.toString();}
        if (typeof elementValue === 'number') {return elementValue === parseInt(value, 10);}
        return elementValue === value;
    }

    getUserDevices(userid) {
        return new Promise(async (resolve, reject) => {
            this.load('INVENTORY')
                .then(data => {
                    let userDev = this.store.database.inventory.filter(item => item.userid === parseInt(userid))
                    resolve(userDev.filter(item => item.type === 'IT'))
                })
                .catch(error => { reject(error) })
        })
    }

    getOfficesByDistrict(districtName) {
        return new Promise(async (resolve, reject) => {
            this.load('CITIES')
            .then(data => {
                let citiesByDistrictName = this.store.database.cities.filter((city => (city.district === districtName)))
                resolve(citiesByDistrictName.filter(city => (city.appearence === 'headoffice' || city.appearence === 'office')).sort((a, b) => a.name.localeCompare(b.name, 'hu')))
               
            })
            .catch(error => { reject(error) })
        })
    }

     getCitiesByUserid(userid) {
        return new Promise(async (resolve, reject) => {
            this.load('CITYUSERS')
            .then(async cityUsers => {
                let cityusersByuserid = await this.store.database.cityusers.filter((cityUser => (cityUser.userid === userid)))
                let actualCities = []
                cityusersByuserid.forEach(async cityUser => {
                    if(cityUser.isthere === 'IGAZ'){
                        await this.load('CITIES')
                        const city = await this.store.database.cities.find(city => parseInt(city.id) === cityUser.cityid);
                        if (city){actualCities.push(city);}
                    }
                    
                });
                resolve(actualCities.sort((a, b) => a.name.localeCompare(b.name, 'hu')))
            })
        
        })
    }

    async getUsersByCityid(cityid) {
        await this.load('CITYUSERS');
        const cityUsersRows = this.store.database.cityusers.filter(row => row.cityid === cityid && row.isthere === 'IGAZ');
        const users = await Promise.all(
            cityUsersRows.map(async row => {
                const user = await this.findOne('USERS', 'id', row.userid);
                return user;
            })
        );
        const result = users.filter(user => user !== undefined);
        return result;
    }

    async existingCityUserEntry(cityid, userid) {
        //console.log('cityid', cityid)
        let answer = {process: '', existingCityUsersEntry: null}
        return new Promise(async (resolve, reject) => {
            this.load('CITYUSERS')
                .then(cityUsers => {
                   let cityUsersByCityid = this.store.database.cityusers.filter(row => row.cityid === cityid)
                   answer.process = 'SAVE'
                    if (cityUsersByCityid.length > 0) {
                        let cityUsersByUserid = cityUsersByCityid.filter(row => row.userid === userid);
                        if (cityUsersByUserid.length > 0) {
                            answer.existingCityUsersEntry = cityUsersByUserid[0];
                            answer.process = 'MODIFY';
                        }
                    }else{
                        answer.process = 'SAVE'
                    }
                    resolve(answer)
                })
             .catch(error => { reject(error) })
        })
    }

    getOfficeRolldownByDistrict(district) {
        return new Promise(async (resolve, reject) => {
            this.load('CITIES')
                .then(data => {
                    let byDistrictName = this.store.database.cities.filter((city => (city.district === district)))
                    let officeRolldown = null
                    if(district === 'Tesztkörzet'){
                        officeRolldown = byDistrictName.filter((city => (city.appearence === 'other')));
                    }else{
                         officeRolldown = byDistrictName.filter((city => (city.appearence === 'headoffice' || city.appearence === 'office')));
                    }
                   
                    officeRolldown.unshift({name: 'válassz!'})
                    resolve(officeRolldown)
                })
                .catch(error => { reject(error) })
        })
    }

    async createExportData(list) {
        const required = new Set();

        // Megnézzük, mely adatbázisokra van szükség
        list.forEach(item => {
            Object.keys(item).forEach(key => {
                if (key === "userid") {required.add("USERS");}
                if (key === "officeid" || key === "cityid") {required.add("CITIES");}
                if (key === "itemid") {required.add("INVENTORY");}
            });
        });

        // Szükséges adatbázisok betöltése
        await Promise.all([...required].map(reference => this.load(reference)));

        const databases = {
            userid: this.store.database.users,
            officeid: this.store.database.cities,
            cityid: this.store.database.cities,
            itemid: this.store.database.inventory
        };

        // ÚJ tömb létrehozása
        this.store.database.exportdatas = [];
        this.store.database.exportdatas = list.map(item => {

            // Az eredeti objektum másolata
            const exportItem = { ...item };

            Object.entries(item).forEach(([key, value]) => {
                const database = databases[key];
                if (!database) return;
                // Alapértelmezett érték null
                let name = null;
                // Csak akkor keresünk, ha van ID
                if (value !== null && value !== undefined && value !== "") {
                    const found = database.find(entry => Number(entry.id) === Number(value));
                    if (found) {
                        if (key === "itemid") {
                            name = [found.category, found.model]
                            .filter(Boolean)
                            .join(" - ");
                        } else {name = found.name;}
                    }
                }
                // A mező MINDIG bekerül
                exportItem[`${key}name`] = name;
            });
            return exportItem;
        });
        return this.store.database.exportdatas;
    }

    async export(reference) {
        await this.load(reference);
        await this.createExportData(this.store.database[reference.toLowerCase()]);
        return this.store.database.exportdatas;
    }

    load(reference) {
        return new Promise(async (resolve, reject) => {
            if(this.store.database[`${reference.toLowerCase()}`] === null || this.store.database[`${reference.toLowerCase()}`] === undefined){
                READ(`${reference}`)
                .then(data => {
                    this.store.database[`${reference.toLowerCase()}`] = data
                    resolve('LOADED')
                })
                .catch(error => { reject(error) })
            }else{resolve('LOADED')}
        })
    }

    async modify(reference, data, log) {
        try {
            const response = await UPDATE(reference, data.firestoreid, data);
            // LOG MENTÉSE
            if (log !== null) {
                await this.saveLog('LOGS', log);
                this.store.database[reference.toLowerCase()] = null;
                await this.load(reference);
                this.store.events.dispatchEvent(new CustomEvent("databaseUpdated", {detail: {reference: reference}}));
                return 'MODIFIED';
            }else{
                this.store.database[reference.toLowerCase()] = null;
                await this.load(reference);
                this.store.events.dispatchEvent(new CustomEvent("databaseUpdated", {detail: {reference: reference}}));
            }
            return response;
        } catch (error) {throw error;}
    }

    async save(reference, data, log) {
        try {
            let nextid = await this.getNextId(reference) + 1;
            data.id = nextid;
            const response = await CREATE(reference, data);
            // LOG MENTÉSE
            if (log !== null) {
                log.itemid = nextid
                await this.saveLog("LOGS", log);
                this.store.database[reference.toLowerCase()] = null;
                await this.load(reference);
                this.store.events.dispatchEvent(new CustomEvent("databaseUpdated", {detail: {reference: reference}}));
            }else{
                this.store.database[reference.toLowerCase()] = null;
                await this.load(reference);
                this.store.events.dispatchEvent(new CustomEvent("databaseUpdated", {detail: {reference: reference}}));
            }
                
            return response;
        } catch (error) {throw error;}
    }

    async saveLog(reference, data) {
        return new Promise(async (resolve, reject) => {
            data.id = await this.getNextId(reference) + 1;
            
            CREATE(reference, data)
            .then(async response => {
                this.store.database[reference.toLowerCase()] = null;
                await this.load(reference);
                this.store.events.dispatchEvent(new CustomEvent("databaseUpdated", {detail: {reference: reference}}));
                resolve(response)})
            .catch(error => {reject(error)})
        })
    }

    getNextId(reference) {
        return new Promise(async (resolve, reject) => {
            this.load(reference)
            .then(data => {resolve(this.store.database[reference.toLowerCase()].reduce((max, item) => Math.max(max, item.id), 0))})
            .catch(error => { reject(error) })
           
        })
    }

    async poolEmail(email) {
        try {
            const checkUserEmail = httpsCallable(functions, "checkUserEmail");
            const result = await checkUserEmail({ email });
            return result.data.user;
        } catch (error) {throw error;}
    }

    checkEmail(email) {return this.store.database.users.some(user => user.email === email);}
}